//主页面
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');
//菜单管理
const menu = () => import(/* webpackChunkName:'grounp' */ '@/pages/systemManage/menu.vue');
//角色管理
const role = () => import(/* webpackChunkName:'grounp' */ '@/pages/systemManage/role.vue');
//应用管理
const application = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/systemManage/application.vue');
//应用管理
const account = () => import(/* webpackChunkName:'grounp' */ '@/pages/systemManage/account.vue');
//数据字典
const dict = () => import(/* webpackChunkName:'grounp' */ '@/pages/systemManage/dict.vue');
//账套管理-查询
const AccountList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/systemManage/account/AccountList.vue');
//账套管理-创建
const creatAccount = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/systemManage/account/creatAccount.vue');
//账套管理-查看详情
const viewAccount = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/systemManage/account/viewAccount.vue');
//审批中心
const approvalCenter = (r) =>
  require.ensure([], () => r(require('@/pages/systemManage/approvalCenter.vue')), 'approvalCenter');

// 系统配置
const sysConfig = (r) =>
  require.ensure([], () => r(require('@/pages/systemManage/config/list.vue')), 'sysConfig');
// 系统配置
const sysConfigEdit = (r) =>
  require.ensure([], () => r(require('@/pages/systemManage/config/edit.vue')), 'sysConfigEdit');

//公告管理
const notice = (r) =>
  require.ensure([], () => r(require('@/pages/systemManage/notice/index.vue')), 'notice');
//系统日志
const journal = (r) =>
  require.ensure([], () => r(require('@/pages/systemManage/journal/index.vue')), 'journal');

const systemRouter = {
  path: '/system',
  component: index,
  children: [
    {
      path: 'sysConfig',
      name: 'sysConfig',
      component: sysConfig,
      meta: {
        keepAlive: true,
        title: '系统配置',
      },
    },
    {
      path: 'sysConfigAdd',
      name: 'sysConfigAdd',
      component: sysConfigEdit,
      meta: {
        keepAlive: true,
        title: '新增系统配置',
      },
    },
    {
      path: 'sysConfigEdit',
      name: 'sysConfigEdit',
      component: sysConfigEdit,
      meta: {
        keepAlive: true,
        title: '修改系统配置',
      },
    },
    {
      path: 'menu',
      name: 'menu',
      component: menu,
      meta: {
        keepAlive: true,
        title: '菜单管理',
      },
    },
    {
      path: 'role',
      name: 'role',
      component: role,
      meta: {
        keepAlive: true,
        title: '角色管理',
      },
    },
    {
      path: 'application',
      name: 'application',
      component: application,
      meta: {
        keepAlive: true,
        title: '应用管理',
      },
    },
    {
      path: 'account',
      name: 'account',
      component: account,
      meta: {
        keepAlive: true,
        title: '账号管理',
      },
    },
    {
      path: 'dict',
      name: 'dict',
      component: dict,
      meta: {
        keepAlive: true,
        title: '字典管理',
      },
    },
    {
      path: 'AccountList',
      name: 'AccountList',
      component: AccountList,
      meta: {
        keepAlive: true,
        title: '查询账套',
      },
    },
    {
      path: 'creatAccount',
      name: 'creatAccount',
      component: creatAccount,
      meta: {
        keepAlive: true,
        title: '创建账套',
      },
    },
    {
      path: 'viewAccount',
      name: 'viewAccount',
      component: viewAccount,
      meta: {
        keepAlive: true,
        title: '分类账选项',
      },
    },
    {
      path: 'approvalCenter',
      name: 'approvalCenter',
      component: approvalCenter,
      meta: {
        keepAlive: true,
        title: '审批中心',
      },
    },
    {
      path: 'notice',
      name: 'notice',
      component: notice,
      meta: {
        keepAlive: true,
        title: '公告管理',
      },
    },
    {
      path: 'journal',
      name: 'journal',
      component: journal,
      meta: {
        keepAlive: true,
        title: '系统日志',
      },
    },
  ],
};
export default systemRouter;
